import React from "react";
import Layout from "layouts";
import WeeklySlotsComponent from "./WeeklySlotsComponent";

export default function WeeklySlots() {
  return (
    <Layout breadCrumb={[{ label: "Dispatch Dates", to: "#" }]}>
      <WeeklySlotsComponent />
    </Layout>
  );
}
